import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {SpecLineModel} from '../../properties/models/spec-line.model';
import {MasterOperationModel} from "../../manufacturing/models/master-operation.model";
import {
  MasterInputInstructionModel,
  MasterOutputInstructionModel
} from "../../manufacturing/models/master-input-instruction.model";
import {MasterUseInstructionModel} from "../../manufacturing/models/master-use-instruction.model";
import {ManufacturingItemGroupModel} from "../../manufacturing/models/manufacturing-item-group.model";
import {ManufacturingItemModel} from "../../manufacturing/models/manufacturing-item.model";

@Pipe({
  name: 'filterSpecsBySource'
})
@Injectable({
  providedIn: 'root'
})
export class FilterSpecsBySourcePipe implements PipeTransform {

  transform(specs: SpecLineModel[], container: MasterOperationModel | MasterInputInstructionModel | MasterOutputInstructionModel | MasterUseInstructionModel | ManufacturingItemGroupModel | ManufacturingItemModel): SpecLineModel[] {
    if (container instanceof ManufacturingItemGroupModel || container instanceof ManufacturingItemModel) {
      return specs.filter(spec => {
        const lineSourceIsEqual = spec.LineSource?.Id === container.Id;
        const mappingSourceIsEqual = spec.MappingSource?.Id === container.Id;
        return lineSourceIsEqual || mappingSourceIsEqual;
      });
    }

    if (container instanceof MasterOperationModel) {
      return specs;
    }

    return specs.filter(spec => {
      let lineSourceId = spec.LineSource?.Id ?? container.Id;
      const lineSourceIsEqual = lineSourceId === container.Id || lineSourceId === container.ParentId;

      let mappingSourceId = spec.MappingSource?.Id ?? container.Id;
      const mappingSourceIsEqual = mappingSourceId === container.Id || mappingSourceId === container.ParentId;

      return lineSourceIsEqual && mappingSourceIsEqual;
    });
  }
}
